// Small deterministic RNG so games can be seeded in tests. Defaults to Math.random in play.

export interface RNG {
  /** float in [0, 1) */
  next(): number;
  /** integer in [0, maxExclusive) */
  int(maxExclusive: number): number;
}

export function mathRandomRNG(): RNG {
  return {
    next: () => Math.random(),
    int: (max) => Math.floor(Math.random() * max),
  };
}

/** mulberry32 — fast, decent quality, seedable. */
export function seededRNG(seed: number): RNG {
  let a = seed >>> 0;
  const next = () => {
    a |= 0;
    a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (max) => Math.floor(next() * max),
  };
}
